import { render, staticRenderFns } from "./bankManagerDc.vue?vue&type=template&id=4970e05e&scoped=true"
import script from "./bankManagerDc.vue?vue&type=script&lang=js"
export * from "./bankManagerDc.vue?vue&type=script&lang=js"
import style0 from "./bankManagerDc.vue?vue&type=style&index=0&id=4970e05e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4970e05e",
  null
  
)

export default component.exports